import Spinner from '@xo-union/tk-component-spinner';
import { H1, H4 } from '@xo-union/tk-ui-typography';
import React, { useState } from 'react';

import { GuestMessagingStatusesQuery, useGuestMessagingStatusesQuery } from '../../generated/graphql';
import SentMessageItem, { Batch } from './SentMessageItem';
import SentMessageRail from './SentMessageRail';
import styles from './sentMessages.scss';

export type Guests = NonNullable<NonNullable<GuestMessagingStatusesQuery['guestMessagingStatuses']>[0]>['guests'];

const SentMessages: React.FC = () => {
  // https://www.apollographql.com/docs/react/data/error-handling/#error-policies
  // Guest can be deleted in GDS but the records still exist in GMS which will cause error
  const { data, loading } = useGuestMessagingStatusesQuery({ errorPolicy: 'all', fetchPolicy: 'no-cache' });
  const [open, setOpen] = useState(false);
  const [batch, setBatch] = useState<Batch>();

  const close = () => {
    setOpen(false);
    setBatch(undefined);
  };

  const onClickDetail = (b: Batch) => {
    setBatch(b);
    setOpen(true);
  };

  return (
    <div>
      <SentMessageRail open={open} batch={batch} onClose={close} />
      <H1>Sent &amp; Scheduled Messages</H1>
      {!data || loading ? (
        <div className={styles.loadingContainer}>
          <Spinner />
        </div>
      ) : (
        <div>
          {data.guestMessagingStatuses?.length ? (
            data.guestMessagingStatuses.map(batch => {
              if (batch) {
                return <SentMessageItem key={batch.batchId} onClickDetail={onClickDetail} {...batch} />;
              }
              return null;
            })
          ) : (
            <H4 className={styles.emptyMsg}>Check back here to see all the messages you've sent.</H4>
          )}
        </div>
      )}
    </div>
  );
};

export default SentMessages;
